import { lazy } from 'react';

export const PropertiesPageAsync = lazy(() => import('./PropertiesPage'));
